import Hero from "../components/hero";
import heroSafety from "@assets/images/safety-hero.svg";
import heroGuidelines from "@assets/images/safety-guidelines-hero.svg";
import heroFaq from "@assets/images/faq-hero.svg";
import heroFeedback from "@assets/images/customer-feedback-hero.svg";
import { openMailto } from "@/utils/mailto";
import {
  SafetyEmergencyPage,
  SafetyGuidelinesPage,
  CustomerFeedbackPage,
  FAQPage,
} from "@features/general";

export function BusinessSafetyEmergency() {
  return (
    <SafetyEmergencyPage
      hero={
        <Hero
          data={{
            title: "Your Safety Is Our Highest Priority",
            description:
              "At Gaz Investment in Oil and Gas Supply L.L.C. (GAZ), every installation, meter, and delivery is performed under strict UAE safety regulations.",
            image: heroSafety,
            buttonText: "View Safety Guidelines",
            buttonOnclick: () => (window.location.href = "/business/safety/safety-guidelines"),
            footerText:
              "Our licensed technicians and 24/7 emergency response team are always ready to protect your home and business.",
            footerButtonText: "Report an Emergency Online",
            footerButtonOnclick: () =>
              openMailto({ subject: "Emergency Report", body: "Emergency Type:\nLocation:\nDescription:\n" }),
          }}
        />
      }
    />
  );
}

export function BusinessSafetyGuidelines() {
  return (
    <SafetyGuidelinesPage
      hero={
        <Hero
          data={{
            title: "Your Safety Comes First, Every Second Counts",
            description:
              "Gas safety is a shared responsibility. GAZ ensures certified installations, strict inspections, and 24/7 emergency support.",
            image: heroGuidelines,
            buttonText: "Call 800-GAZ (42747)",
            buttonOnclick: () => (window.location.href = "tel:800-GAZ"),
            footerText:
              "Our licensed technicians and 24/7 emergency response team are always ready to protect your home and business.",
            footerButtonText: "Report an Emergency Online",
            footerButtonOnclick: () =>
              openMailto({ subject: "Emergency Report", body: "Emergency Type:\nLocation:\nDescription:\n" }),
          }}
        />
      }
    />
  );
}

export function BusinessCustomerFeedback() {
  return (
    <CustomerFeedbackPage
      hero={
        <Hero
          data={{
            title: "Help Us Improve Your GAZ Experience",
            description:
              "We are committed to delivering safe, reliable, and high-quality gas services. Your feedback helps us enhance our operations, customer support, digital tools, and overall service delivery.",
            image: heroFeedback,
            footerText:
              "Every complaint is tracked with a unique reference number for full transparency.",
            footerButtonText: "Talk to Our Team",
            footerButtonOnclick: () => openMailto({ subject: "Customer Feedback Inquiry" }),
          }}
        />
      }
    />
  );
}

export function BusinessFAQ() {
  return (
    <FAQPage
      hero={
        <Hero
          data={{
            title: "We're Here to Help, 24 Hours a Day",
            description:
              "At Gaz Investment in Oil and Gas Supply L.L.C. (GAZ), our goal is to make every step of your gas experience simple and transparent.",
            image: heroFaq,
            buttonText: "Report an issue",
            buttonOnclick: () =>
              openMailto({ subject: "Issue Report", body: "Issue Type:\nAccount Number:\nDescription:\n" }),
            footerText:
              "Use the self-service tools, browse our FAQs, or contact our support team for immediate help.",
            footerButtonText: "Report an Emergency Online",
            footerButtonOnclick: () =>
              openMailto({ subject: "Emergency Report", body: "Emergency Type:\nLocation:\nDescription:\n" }),
          }}
        />
      }
    />
  );
}
